module.exports = __webpack_public_path__ + "static/blog_convert_screenshots-23243f40b16eea43d08682143e1bf5ab.png";